import classNames from "classnames";
var classes = {
    base: 'inner lg:col-start-2 lg:col-end-12 xl:col-start-3 xl:col-end-11 2xl:col-start-4 2xl:col-end-10',
};
var FormCol = function (_a) {
    var children = _a.children, className = _a.className;
    return (<div className={classNames(classes.base, className)}>
      {children}
    </div>);
};
export default FormCol;
